var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInfoLit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 14.6654C4.31767 14.6654 1.33301 11.6807 1.33301 7.9987C1.33301 4.3167 4.31767 1.33203 7.99967 1.33203C11.6817 1.33203 14.6663 4.3167 14.6663 7.9987C14.6663 11.6807 11.6817 14.6654 7.99967 14.6654ZM7.99967 13.332C9.41416 13.332 10.7707 12.7701 11.7709 11.7699C12.7711 10.7697 13.333 9.41319 13.333 7.9987C13.333 6.58421 12.7711 5.22766 11.7709 4.22746C10.7707 3.22727 9.41416 2.66536 7.99967 2.66536C6.58519 2.66536 5.22863 3.22727 4.22844 4.22746C3.22824 5.22766 2.66634 6.58421 2.66634 7.9987C2.66634 9.41319 3.22824 10.7697 4.22844 11.7699C5.22863 12.7701 6.58519 13.332 7.99967 13.332V13.332ZM7.33301 4.66536H8.66634V5.9987H7.33301V4.66536ZM7.33301 7.33203H8.66634V11.332H7.33301V7.33203Z",
    fill: "#7E8299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoLit);
export default __webpack_public_path__ + "static/media/ic-info-lit.cabc561f81fb1919a1754ad58c2e4c99.svg";
export { ForwardRef as ReactComponent };